import { render, staticRenderFns } from "./BoardFilterQnaLayout.vue?vue&type=template&id=5c5f956c&scoped=true"
import script from "./BoardFilterQnaLayout.vue?vue&type=script&lang=js"
export * from "./BoardFilterQnaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f956c",
  null
  
)

export default component.exports